import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=487c85e2&scoped=true&"
import script from "./MenuMobile.vue?vue&type=script&lang=js&"
export * from "./MenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=487c85e2&prod&lang=scss&scoped=true&"
import style1 from "./MenuMobile.vue?vue&type=style&index=1&id=487c85e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c85e2",
  null
  
)

export default component.exports